var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCraEquipmentTopBarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 1C5.5 0.447715 5.94772 0 6.5 0H13.5C14.0523 0 14.5 0.447715 14.5 1V5.5C14.5 6.05228 14.0523 6.5 13.5 6.5H11V9H15.5C16.0523 9 16.5 9.44771 16.5 10V13.5H19C19.5523 13.5 20 13.9477 20 14.5V19C20 19.5523 19.5523 20 19 20H12C11.4477 20 11 19.5523 11 19V14.5C11 13.9477 11.4477 13.5 12 13.5H14.5V11H5.5V13.5H8C8.55228 13.5 9 13.9477 9 14.5V19C9 19.5523 8.55228 20 8 20H1C0.447715 20 0 19.5523 0 19V14.5C0 13.9477 0.447715 13.5 1 13.5H3.5V10C3.5 9.44771 3.94772 9 4.5 9H9V6.5H6.5C5.94772 6.5 5.5 6.05228 5.5 5.5V1ZM2 15.5V18H7V15.5H2ZM13 15.5V18H18V15.5H13ZM7.5 2V4.5H12.5V2H7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraEquipmentTopBarIcon);
export default __webpack_public_path__ + "static/media/cra-equipment-top-bar-icon.49a0e1a395aa1b9e3d5e74a7f30110af.svg";
export { ForwardRef as ReactComponent };